/**
 * Read-only SVG граф для тренажёра graph1.
 * Данные: { nodes: [{id,x,y,label?,highlight?}], edges: [{id,from,to,weight?}], width?, height? }
 */
export default function TrainerGraphSvg({
  graph,
  compact = false,
  className = '',
}) {
  if (!graph?.nodes?.length) return null;

  const width = graph.width || 320;
  const height = graph.height || 280;
  const nodesById = new Map(graph.nodes.map((n) => [n.id, n]));
  const r = compact ? 14 : 18;

  return (
    <svg
      className={`trainer-graph-svg ${compact ? 'is-compact' : ''} ${className}`.trim()}
      viewBox={`0 0 ${width} ${height}`}
      width="100%"
      height={compact ? 160 : 240}
      role="img"
      aria-label="Граф дорог"
    >
      {(graph.edges || []).map((e) => {
        const a = nodesById.get(e.from);
        const b = nodesById.get(e.to);
        if (!a || !b) return null;
        const mx = (a.x + b.x) / 2;
        const my = (a.y + b.y) / 2;
        return (
          <g key={e.id || `${e.from}-${e.to}`}>
            <line
              x1={a.x}
              y1={a.y}
              x2={b.x}
              y2={b.y}
              className="trainer-graph-edge"
            />
            {e.weight != null && e.weight !== '' ? (
              <text
                x={mx}
                y={my - 5}
                className="trainer-graph-edge-label"
                textAnchor="middle"
              >
                {e.weight}
              </text>
            ) : null}
          </g>
        );
      })}
      {graph.nodes.map((n) => (
        <g
          key={n.id}
          transform={`translate(${n.x},${n.y})`}
          className={`trainer-graph-node ${n.highlight ? 'is-highlight' : ''}`}
        >
          <circle r={r} />
          {n.label ? (
            <text textAnchor="middle" dy="5">
              {n.label}
            </text>
          ) : null}
        </g>
      ))}
    </svg>
  );
}
